import { render, staticRenderFns } from "./IconKruisAppendix.vue?vue&type=template&id=d937eae8"
import script from "./IconKruisAppendix.vue?vue&type=script&lang=ts"
export * from "./IconKruisAppendix.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports